import api from '@/lib/axios';

/** Strip spaces/dashes and uppercase. */
export function normalizeIban(iban) {
  return String(iban || '').replace(/[\s-]/g, '').toUpperCase();
}

/**
 * Lookup BIC / bank name for an IBAN via backend (schwifty).
 * Tries guardians (payers) first, then sepa — whichever the user may access.
 * Returns null on network/validation failure; never throws.
 */
export async function lookupIbanInfo(iban) {
  const cleaned = normalizeIban(iban);
  if (cleaned.length < 15) return null;
  for (const path of ['/guardians/iban-lookup', '/sepa/iban-lookup']) {
    try {
      const res = await api.get(path, { params: { iban: cleaned } });
      if (res.data?.valid) return res.data;
      if (res.data && res.data.valid === false) return null;
    } catch {
      /* try next */
    }
  }
  return null;
}
